import { useFxWorkspaceContext } from '@mobile-mapping/providers';
import { t } from '@trimble/i18n';
import { BtnClasses, IconButton } from '@tcweb/connect-ui';
import { Component, JSX } from 'solid-js';

export interface FxNewExtractionButtonProps {
  readonly workspaceId: string;
}

export const FxNewExtractionButton: Component<FxNewExtractionButtonProps> = (
  props
): JSX.Element => {
  const fxWorkspace = useFxWorkspaceContext();

  const stopTreeRowInteraction = (event: Event): void => {
    event.stopPropagation();
  };

  const handleNewExtraction = (event: MouseEvent): void => {
    stopTreeRowInteraction(event);
    fxWorkspace.openNewExtractionDialog();
  };

  return (
    <span class="inline-flex" onPointerDown={stopTreeRowInteraction}>
      <IconButton
        color={BtnClasses.TERTIARY}
        icon="tc-icon-content-add"
        size="icon-medium"
        data-cy={`fx-new-extraction-${props.workspaceId}`}
        title={t('mobileMapping.fxWorkspace.extraction.newExtraction')}
        clicked={handleNewExtraction}
      />
    </span>
  );
};
